<template>

  <v-card>
    <v-app-bar color="primary" dark flat>
      <v-toolbar-title>
        <v-icon left>mdi-cash-register</v-icon>
        Resumo do Caixa
      </v-toolbar-title>

      <v-spacer />

      <v-chip outlined small>
        <v-icon left small>mdi-account</v-icon>
        {{ cashier.user?.name || 'Usuário Desconhecido' }}
      </v-chip>
      <v-chip outlined small class="ml-2">
        <v-icon left small>mdi-clock-outline</v-icon>
        {{ cashier.started || 'N/A' }}
      </v-chip>
    </v-app-bar>

    <v-row class="mt-4" dense>
      <v-col cols="12" sm="6" md="3">
        <v-card dark class="summary-card">
          <v-card-text class="d-flex flex-column align-center">
            <v-icon size="28" color="blue darken-2">mdi-cart</v-icon>
            <div class="subtitle-1 font-weight-bold blue--text mt-2">
              {{ cashier.total_orders || 0 }}
            </div>
            <div class="caption grey--text text-uppercase mt-1">vendas</div>
            <v-progress-linear :value="(cashier.total_orders / 50) * 100" color="blue darken-2" height="3" class="mt-3"
              rounded />
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card dark class="summary-card">
          <v-card-text class="d-flex flex-column align-center">
            <v-icon size="28" color="green darken-2">mdi-cash</v-icon>
            <div class="subtitle-1 font-weight-bold green--text mt-2">
              {{ cashier.initial_cash | currency }}
            </div>
            <div class="caption grey--text text-uppercase mt-1">caixa inicial</div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card dark class="summary-card">
          <v-card-text class="d-flex flex-column align-center">
            <v-icon size="28" color="blue darken-2">mdi-arrow-up-bold</v-icon>
            <div class="subtitle-1 font-weight-bold blue--text mt-2">
              {{ cashier.inputs | currency }}
            </div>
            <div class="caption grey--text text-uppercase mt-1">entradas</div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card dark class="summary-card">
          <v-card-text class="d-flex flex-column align-center">
            <v-icon size="28" color="red darken-2">mdi-arrow-down-bold</v-icon>
            <div class="subtitle-1 font-weight-bold red--text mt-2">
              {{ cashier.outputs | currency }}
            </div>
            <div class="caption grey--text text-uppercase mt-1">saídas</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-card>

</template>

<script>
  import { mapActions, mapState } from 'vuex'
  export default {
    methods: {
      ...mapActions('cashier', ['activeCashier'])
    },
    computed: {
      ...mapState('cashier', ['cashier'])
    },
    created() {
      this.activeCashier()
    }
  }
</script>

<style scoped>
  .summary-card {
    height: 140px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
  }
</style>
